import { Camelized } from "humps";
import { z } from "zod";

export interface IHashtag {
	uuid: string;

	name: string;

	is_private: boolean;

	color: string;
}

export const HashtagOutputSchema = z.object({
	uuid: z.string().uuid(),

	name: z.string(),

	isPrivate: z.boolean(),

	color: z.string()
});

export type HashtagModel = Camelized<IHashtag>;
